import { fmtDateTime } from "@/lib/constants";
import { StatusBadge } from "@/components/StatusBadge";

export const StatusTimeline = ({ history = [] }) => (
  <ol className="relative ml-2 border-l-2 border-[#E2E5DC]" data-testid="status-timeline">
    {[...history].reverse().map((h, i) => (
      <li key={i} className="mb-6 ml-5 last:mb-0" data-testid={`timeline-entry-${i}`}>
        <span className="absolute -left-[7px] mt-1.5 h-3 w-3 rounded-full border-2 border-white bg-[#0F2D5E]" />
        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge status={h.status} />
          <span className="font-mono text-xs text-[#75867E]">{fmtDateTime(h.at)}</span>
          <span className="text-xs text-[#75867E]">· {h.by}</span>
        </div>
        {h.note && <p className="mt-1.5 text-sm text-[#495850]">{h.note}</p>}
      </li>
    ))}
  </ol>
);
